import Vue from 'vue';
import { produceKey } from '@/core/utils/helper';
import * as types from './mutation_types';

export default {
  [types.SET_CREDIT_BALANCE](state, data) {
    Vue.set(state, 'creditBalance', data);
  },

  [types.SET_TALKS](state, data) {
    Vue.set(state, 'talks', data);
  },

  [types.SET_TALKS_META](state, meta) {
    Vue.set(state, 'talksMeta', meta);
  },

  [types.LOAD_MORE_TALKS](state, data) {
    Vue.set(state, 'talks', [...state.talks, ...data]);
  },

  [types.DELETE_TALK](state, id) {
    Vue.set(state, 'talks', state.talks.filter(talk => talk._id !== id));
  },

  [types.SET_ACTIVE_TALK_ID](state, id) {
    Vue.set(state, 'activeTalkId', id);
  },

  [types.SET_ACTIVE_TALK](state, talk) {
    Vue.set(state, 'activeTalk', talk);
  },

  [types.UPDATE_TALK](state, talk) {
    Vue.set(state, 'activeTalk', {
      ...state.activeTalk,
      ai_messages: talk.ai_messages,
    });
  },

  [types.OPEN_UZAIR](state, data) {
    const { config } = data;
    const { payload } = data;
    Vue.set(state, 'uzairPopup', {
      ...state.uzairPopup,
      show: true,
      is_visible: true,
      config,
      payload,
    });
  },

  [types.CLOSE_UZAIR](state) {
    Vue.set(state, 'uzairPopup', {
      ...state.uzairPopup,
      show: false,
      is_visible: false,
      data: false,
    });
  },

  [types.HARD_CLOSE_UZAIR](state) {
    Vue.set(state, 'uzairPopup', {
      ...state.uzairPopup,
      selector: produceKey(),
      show: false,
      is_visible: false,
      data: false,
      config: {},
    });
    Vue.set(state, 'activeTalkId', null);
    Vue.set(state, 'activeTalk', null);
  },

  [types.CLEAR_UZAIR_POPUP_CONFIG](state) {
    Vue.set(state, 'uzairPopup', {
      ...state.uzairPopup,
      show: true,
      is_visible: true,
      data: false,
      config: {},
    });
  },

  [types.ADD_RESPONSE_TRANSFER_MEMORY](state, results) {
    Vue.set(state, 'responseTransferMemory', results);
  },

  [types.TOGGLE_UZAIR_ICON](state, { nextStatus }) {
    Vue.set(state, 'isUzairIconBig', nextStatus);
  },

  [types.MINIMIZE_UZAIR](state) {
    Vue.set(state, 'uzairPopup', {
      ...state.uzairPopup,
      is_visible: false,
    });
  },

  [types.CREATE_EVENT](state, newEvent) {
    Vue.set(state, 'events', [...state.events, {
      ...newEvent,
      event_id: produceKey(),
      created_at: new Date(),
    }]);
  },

  [types.REMOVE_EVENT](state, eventId) {
    Vue.set(state, 'events', state.events.filter(e => e.event_id !== eventId));
  },

  [types.MAKE_IT_IN_PROGRESS_EVENT](state, eventId) {
    Vue.set(state, 'events', state.events.map((e) => {
      if (e.event_id === eventId) {
        return {
          ...e,
          is_in_progress: true,
        };
      }
      return e;
    }));
  },


  [types.TOGGLE_THEME_MODE](state, isDarkMode) {
    Vue.set(state, 'isDarkMode', isDarkMode);
  },

  [types.SET_ACTIVE_CHAT_ID](state, activeChatId) {
    Vue.set(state, 'activeChatId', activeChatId);
  },

  [types.SET_UZAIR_ADMIN_MODE](state, value) {
    Vue.set(state, 'isUzairAdminMode', value);
  },

  [types.UPDATE_UZAIR_APP_KEY](state) {
    Vue.set(state, 'uzairAppKey', produceKey());
  },

  [types.SET_UZAIR_PROGRESS_STATUS](state, value) {
    Vue.set(state, 'uzairIsInProgress', value);
  },
};
